import React from 'react';
import Badge, { BadgeProps } from '@components/common/badge/badge';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { useTranslation } from 'next-i18next';
import { ElasticSearchFacetsFields } from '@interfaces/models/elasticSearch';

type ChipListProps = {
  chips: Chip[];
  chipClassName?: string;
  isMysizesChip?: boolean;
} & BadgeProps;

export type Chip = {
  label: string;
  filterGroup?: ElasticSearchFacetsFields;
  filterIds?: string[];
  isStatic?: boolean;
};

const ChipList: React.FC<ChipListProps> = (props): React.JSX.Element => {
  const { isMysizesChip, chipClassName = '', chips, ...rest } = props;
  const toggleFilter = useContextSelector(CatalogContext, (v) => v.toggleFilter);

  const { t } = useTranslation();

  return (
    <>
      {chips.map((chip: Chip) => (
        <div
          key={`${chip.filterGroup}-${chip?.label}`}
          className={chipClassName}
        >
          <Badge
            onClose={!chip?.isStatic ? () => toggleFilter(chip.filterGroup, chip?.filterIds, chip?.label) : null}
            useFilterRedesignUi={true}
            {...rest}
          >
            {chip.label}
          </Badge>
        </div>
      ))}
      {isMysizesChip && (
        <div className={chipClassName}>
          <Badge {...rest}>{t('PERSO.FILTER_SET.TITLE')}</Badge>
        </div>
      )}
    </>
  );
};

export default ChipList;
